import moment from "moment";

import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { AttachedObjectResponse } from "@/Common/Models/FileSelection/Responses/AttachedObject";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { ExportableFile } from "./ExportableFile";

class ExportableFileModel implements ITableDataSourceItem<ExportableFile> {
    public Model: ExportableFile;
    public Name: string;
    public isChecked: boolean;
    public isLoaded: boolean;
    public itemId: number;
    public isDisabled: boolean;

    public displayOption: ExportableFileDisplayOption = ExportableFileDisplayOption.NAME_DATE_TYPE;
    public get displayDescription(): string {
        switch (this.displayOption) {
            case ExportableFileDisplayOption.NAME:
                return this.Model.description;

            case ExportableFileDisplayOption.NAME_DATE_TYPE:
            default:
                var result = this.Model.description;
                if (this.Model) {
                    result += " - (" + moment(this.Model.date).format("YYYY/MM/DD") + ")";
                    result += " - " + FileSelectionHelper.determineTypeName(this.Model.fileType);
                }
                return result;
        }
    }

    constructor(
        model: ExportableFile,
        displayOption: ExportableFileDisplayOption,
        isChecked: boolean = false,
        isLoaded: boolean = false,
        itemId: number = sessionStore.newId()
    ) {
        this.Model = model;
        this.displayOption = displayOption;
        this.isChecked = isChecked;
        this.isLoaded = isLoaded;
        this.Name = this.Model.description;
        this.itemId = itemId;
        this.isDisabled = false;
    }

    public ToAttachedObjectResponse(): AttachedObjectResponse {
        let attachedObject = this.Model.toAttachedObject();
        attachedObject.Description = this.displayDescription;
        return attachedObject;
    }
}

enum ExportableFileDisplayOption {
    NAME_DATE_TYPE = 1, // construct display string with name, date and type
    NAME
}

export { ExportableFileDisplayOption, ExportableFileModel };
